import lodash from 'lodash'
import { find } from 'lodash'
import React, { ReactElement, useEffect, useMemo } from 'react'
import styled from 'styled-components'

import Field, {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import InlineEditorInvalid from '../../../../../../../1stlog-ui/src/components/InlineEditor/InlineEditorInvalid'
import Input from '../../../../../../../1stlog-ui/src/components/Input'
import Select from '../../../../../../../1stlog-ui/src/components/Select'
import { useProductSettings } from '../../../../Products'
import useOrderEntry from '../../../../useOrderEntry'

type TPackagingProps = {
  readonly?: boolean
}

const Packaging = (props: TPackagingProps): ReactElement => {
  const { readonly } = props

  const {
    allowedPackagingList,
    isPackagingAllowed,
    allowAnyPackaging,
    defaultPackaging,
  } = useProductSettings()

  const { isOrderEditor } = useOrderEntry()

  const options = useMemo(
    () =>
      allowedPackagingList.map((p) => ({
        value: p.key,
        label: p.name,
      })),
    [allowedPackagingList],
  )

  const [packaging, setPackaging] = useField('packaging', { asState: true })

  useEffect(() => {
    if (allowAnyPackaging) {
      return
    }

    const currentPackaging = packaging || defaultPackaging
    let nextPackaging: string | null = null

    // find nextPackaging
    if (isPackagingAllowed) {
      // select same or default packaging
      nextPackaging =
        lodash.get(
          lodash.find(
            allowedPackagingList,
            (p) => lodash.get(p, 'key') === currentPackaging,
          ),
          'key',
        ) || null

      // if no default given and only one option available, select first
      if (!nextPackaging && lodash.size(allowedPackagingList) === 1) {
        nextPackaging =
          lodash.get(lodash.first(allowedPackagingList), 'key') || null
      }
    }

    // change packaging if it has changed
    if (packaging !== nextPackaging) {
      setTimeout(() => setPackaging(nextPackaging), 0)
    }
  }, [
    allowedPackagingList,
    isPackagingAllowed,
    defaultPackaging,
    allowAnyPackaging,
    packaging,
  ])

  const packagingName = find(
    allowedPackagingList,
    ({ key }) => key === packaging,
  )?.name

  if (
    (readonly && !packagingName) ||
    (!isPackagingAllowed && !allowAnyPackaging)
  ) {
    return <></>
  }

  return (
    <>
      {readonly && (
        <div className="text-center">
          <Label>{i18n.t('packaging_group', 'Verpackungsgruppe')}</Label>
          <h5 className="mt-1">
            {packagingName ? (
              packagingName
            ) : (
              <span className="text-muted">
                {i18n.t('packaging_group_none', 'keine gewählt')}
              </span>
            )}
          </h5>
        </div>
      )}
      <div style={{ minWidth: '250px' }} hidden={readonly}>
        <Field
          name="packaging"
          label={i18n.t('packaging_group', 'Verpackungsgruppe')}
        >
          {allowAnyPackaging ? (
            <Input />
          ) : (
            <Select options={options} direct clearable={isOrderEditor} />
          )}
        </Field>
      </div>
    </>
  )
}

export default Packaging
